import { render, staticRenderFns } from "./LegacyEventSearch.vue?vue&type=template&id=f82e3c4a&scoped=true"
import script from "./LegacyEventSearch.vue?vue&type=script&lang=js"
export * from "./LegacyEventSearch.vue?vue&type=script&lang=js"
import style0 from "./LegacyEventSearch.vue?vue&type=style&index=0&id=f82e3c4a&prod&lang=scss&scoped=true"
import style1 from "./LegacyEventSearch.vue?vue&type=style&index=1&id=f82e3c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82e3c4a",
  null
  
)

export default component.exports